<template>
    <div class="detailInfo">
        
    </div>
</template>
<script>
export default {
    components: { },
    name: "DetailInfo",
    props: {
        listData: {
            type: Object,
            default: () => ({
            })
        },
    },
    data() {
        return {

        }
    },
    mounted() {
        
    },
}
</script>
<style  lang="scss" scoped>
.detailInfo {
    width: 100%;
    margin-top: 8px;
    @include setFlexBetween;
    height: 450px;

    &-left {
        flex-grow: 0;
        width: 459px;

        &-content {
            padding-left: 15px;
        }
    }

    &-center {
        flex-grow: 1;
        margin: 0 8px;
    }

    &-right {
        width: 371px;
        flex-grow: 0;

        &-content {
            padding-right: 15px;
            @include setFlexBetween;

            &>div {
                width: 100%;
                height: 100%;
            }
        }
    }
}
</style>